import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../shared/services/settings.service';
import { PromoEmailTemplateModel } from '../shared/models/promo-email-template-model';
import { PromoEmailTemplateStatus } from '@admin/settings/shared/models/promo-email-template-status.enum';
import { ConfigurationService } from '@admin/shared/services/configuration.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-email-templates-list',
  templateUrl: './email-templates-list.component.html',
  styleUrls: ['./email-templates-list.component.less'],
  standalone: false,
})
export class EmailTemplatesListComponent implements OnInit {
  templates: PromoEmailTemplateModel[];

  PromoEmailTemplateStatusEnum = PromoEmailTemplateStatus;
  dateFormat: string;

  constructor(
    private settingsService: SettingsService,
    private config: ConfigurationService,
    private translateService: TranslateService
  ) {}

  onTemplateDelete(template: PromoEmailTemplateModel) {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      this.settingsService
        .DeleteEmailTemplate(template.promoEmailTemplateId)
        .subscribe((r) => {
          this.loadTemplates();
        });
    }
  }

  onTemplateApprove(template: PromoEmailTemplateModel) {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      this.settingsService
        .ApproveEmailTemplate(template.promoEmailTemplateId)
        .subscribe((r) => {
          this.loadTemplates();
        });
    }
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.dateFormat = config.dateFormat;
    this.loadTemplates();
  }

  private loadTemplates() {
    this.settingsService.ListEmailTemplates().subscribe((r) => {
      this.templates = r.items;
    });
  }
}
